import { render } from "./MainContainer.vue?vue&type=template&id=e3f81bd8&scoped=true"
import script from "./MainContainer.vue?vue&type=script&lang=js"
export * from "./MainContainer.vue?vue&type=script&lang=js"

import "./MainContainer.vue?vue&type=style&index=0&id=e3f81bd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3f81bd8"]])

export default __exports__